<template>
    <div>
        <LoginCom/>
    </div>
</template>
<script>
import LoginForm from '@/components/auth/LoginForm'
export default {
    components:{
        LoginCom: LoginForm,
    }
}
</script>
